import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "@/components/wve/Hero";
import { ClientWall } from "@/components/wve/ClientWall";
import { Services } from "@/components/wve/Services";
import { Manifesto } from "@/components/wve/Manifesto";
import { Photography } from "@/components/wve/Photography";
import { Team } from "@/components/wve/Team";
import { setPageMeta } from "@/lib/seo";

export default function Home() {
  const { hash } = useLocation();

  useEffect(() => {
    setPageMeta(
      "WVE Studios | Video, Photography & Event Production, Essex",
      "WVE Studios is a Wickford, Essex video production, photography & event production company trusted by BAFTA, Shell, Ferrari & F1. Promos, live streams, showreels & studio hire.",
      "/"
    );
  }, []);

  useEffect(() => {
    if (hash) {
      setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" }), 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [hash]);

  return (
    <main>
      <Hero />
      <ClientWall />
      <Services />
      <Manifesto />
      <Photography />
      <Team />
    </main>
  );
}
